export enum LocationType {
  STATE = "state",
  CITY = "city",
  DISTRICT = "district"
}

export enum FeedType {
  TAG = "tag",
  CITY = "city",
  STATE = "state",
  DISTRICT = "district",
  GENERIC = "generic"
}